import { render, staticRenderFns } from "./promissionCheckbox.vue?vue&type=template&id=2370b035&scoped=true"
import script from "./promissionCheckbox.vue?vue&type=script&lang=js"
export * from "./promissionCheckbox.vue?vue&type=script&lang=js"
import style0 from "./promissionCheckbox.vue?vue&type=style&index=0&id=2370b035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370b035",
  null
  
)

export default component.exports